<template>
  <div class="order plaingGoldDeatails">
    <appheader></appheader>
    <div class="box">
      <div>
        <div @mouseenter="stopImglunbo" @mouseleave="mouseLeave" class="magnifier-wrap">
          <svg-icon v-if="DataList.isPresell === '1'" iconClass="pre-sale-label" className="pre-sale-label"></svg-icon>
          <magnifier :src="imgurl"></magnifier>
        </div>
        <div class="banner">
          <div class="slide">
            <div :class="[index == 0 ? 'imgbck' : '', 'imgbox']" v-for="(item, index) in DataList.imgPathList" :key="index" @click="changeImg(index)">
              <img :src="item" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="introduction">
          <div class="productNameClass">{{ DataList.productName }}</div>
          <div>
            <div v-if="!isColleFlag" @click="colleBtn('收藏')" class="introduction cursor">
              <svg-icon iconClass="collection_default" className="collection_default"></svg-icon>收藏商品
            </div>
            <div v-if="isColleFlag" @click="colleBtn('取消')" class="introduction cursor">
              <svg-icon iconClass="collection_selected" className="collection_default"></svg-icon>已收藏
            </div>
          </div>
        </div>
        <div class="content-details">
          <div class="content-details-child">
            <div class="content-details-text" v-if="DataList.styleNumber">
              公司款号：{{ DataList.styleNumber }}<span class="copyText cursor" @click="seccendCopy">复制</span>
            </div>
            <div class="content-details-text" v-if="showProcessingFeeFields">计重加工费单价：{{ DataList.weightProcessingFeePrice }}</div>
            <div class="content-details-text" v-if="showProcessingFeeFields">计件加工费：{{ DataList.pieceProcessingFee }}</div>
            <div class="content-details-text" v-if="DataList.wholesaleLaborCost && hasPriceViewPermission()">
              批发克工费：{{ DataList.wholesaleLaborCost }}
            </div>
            <div class="content-details-text" v-if="DataList.wholesale && hasPriceViewPermission()">批发件工费：{{ DataList.wholesale }}</div>
            <div class="content-details-text" v-if="DataList.pearlWholesale && hasPriceViewPermission()">
              配石批发价：{{ DataList.pearlWholesale }}
            </div>
          </div>
          <div class="content-details-child">
            <div class="content-details-text" v-if="DataList.bigSeries">大系列名：{{ DataList.bigSeries }}</div>
            <div class="content-details-text" v-if="DataList.orderingCycle">订货周期：{{ DataList.orderingCycle }}</div>
            <div class="content-details-text" v-if="DataList.sellingLaborCost">销售克工费：{{ DataList.sellingLaborCost }}</div>
            <!-- <div class="content-details-text" v-if="DataList.salesSurcharge">销售附加费：{{ DataList.salesSurcharge }}</div> -->
          </div>
          <div class="content-details-child">
            <div class="content-details-text" v-if="DataList.mainStoneName">主石名称：{{ DataList.mainStoneName }}</div>
            <div class="content-details-text" v-if="DataList.mainStone">主石重量约：{{ DataList.mainStone }}</div>
            <div class="content-details-text" v-if="DataList.assistStoneNameOne">辅石名称：{{ DataList.assistStoneNameOne }}</div>
            <div class="content-details-text" v-if="DataList.assistStoneOne">辅石重量约：{{ DataList.assistStoneOne }}</div>
          </div>
        </div>
        <div class="box_goumai" v-if="DataList.isCouples === '2'" :class="[$route.query.groupFlag == 1 ? 'onGroup' : '']">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane
              :disabled="DataList.isPresell === '1' || $route.query.groupFlag == 1"
              label="现货"
              name="first"
              v-if="$route.query.groupFlag != 1"
            >
              <Spot
                ref="spot"
                v-if="DataList.stockQuantity > 0"
                @upDataStockQuantity="upDataStockQuantity"
                @updateFactorySource="updateFactorySource('spot', $event)"
                :leastQuantity="DataList.leastQuantity"
                :settlement-method-list="settlementMethodList"
                :DataList="DataList"
              />
            </el-tab-pane>
            <el-tab-pane v-if="hasMainBodyType()[0].value !== '2'" :label="$route.query.groupFlag == 1 ? '预售拼团' : '定单'" name="second">
              <Custom
                ref="custom"
                @updateFactorySource="updateFactorySource('custom', $event)"
                :leastQuantity="DataList.leastQuantity"
                :settlement-method-list="settlementMethodList"
                :DataList="DataList"
                :groupFlag="$route.query.groupFlag"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 情侣对戒 -->
        <div v-if="DataList.isCouples === '1'" :class="[$route.query.groupFlag == 1 ? 'onGroup' : '']">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane
              v-if="$route.query.groupFlag != 1"
              :disabled="DataList.isPresell === '1' || $route.query.groupFlag == 1"
              label="现货"
              name="first"
            >
              <LoversSpot
                v-if="DataList.stockQuantity > 0"
                ref="loversSpot"
                @updateFactorySource="updateFactorySource('loversSpot', $event)"
                :settlement-method-list="settlementMethodList"
                :leastQuantity="DataList.leastQuantity"
                :DataList="DataList"
              />
            </el-tab-pane>
            <el-tab-pane v-if="hasMainBodyType()[0].value !== '2'" :label="$route.query.groupFlag == 1 ? '预售拼团' : '定单'" name="second">
              <LoversCustom
                :leastQuantity="DataList.leastQuantity"
                :settlement-method-list="settlementMethodList"
                ref="loversCustom"
                @updateFactorySource="updateFactorySource('loversCustom', $event)"
                :DataList="DataList"
                :groupFlag="$route.query.groupFlag"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="subscribeToContainer" v-if="activeName === 'first' && DataList.stockQuantity == 0">
          <div class="subscribeTo" @click="updateSubscribe" v-if="!isSubscribe">
            <img src="../../Img/detaile/not-subscribe-to.png" alt="" /> 订阅到货通知
          </div>
          <div class="subscribeTo hasSubscribe" @click="updateSubscribe" v-if="isSubscribe">
            <img src="../../Img/detaile/has-subscribe-to.png" alt="" /> 已订阅到货通知
          </div>
        </div>
        <div class="addClass" v-if="(activeName === 'first' && DataList.stockQuantity > 0) || activeName === 'second'">
          <!-- 点击感兴趣 -->
          <BeInterestedIn
            @interestedInUpdata="interestedInUpdata"
            :id="$route.query.id"
            :isLikeTwo="DataList.isLikeTwo"
            :isPresell="DataList.isPresell"
            :styleNumber="DataList.styleNumber"
          ></BeInterestedIn>
          <div class="onebottom">
            <el-button @click="pushshopping('cart')" class="pushCart" v-if="$route.query.groupFlag != 1">加入购物车</el-button>
            <el-button @click="pushshopping('order')">{{ $route.query.groupFlag != 1 ? '立即购买' : '拼团购买' }}</el-button>
          </div>
        </div>
      </div>
      <div class="toBottom topBottom" v-if="!goTopShow && (recommendationList.length > 0 || mantleSystemList.length > 0)" @click="bottomScrollClick">
        <svg-icon iconClass="gengduotuijian" className="gengduotuijian"></svg-icon>
        更多推荐
      </div>
    </div>
    <!-- 套系推荐 -->
    <MantleSystemRecommended :mantleSystemList="mantleSystemList" :codeType="$route.query.codeType"> </MantleSystemRecommended>
    <!-- 相似推荐 -->
    <SimilarRecommendation :recommendationList="recommendationList" :codeType="$route.query.codeType"> </SimilarRecommendation>
    <bottom></bottom>
    <div class="toTop topBottom" @click="topScrollClick" v-if="goTopShow">
      <svg-icon iconClass="fanhuidingbu" className="gengduotuijian"></svg-icon>
      返回顶部
    </div>
    <SubmitDialog
      v-if="submitDialogVisible"
      :submitDialogVisible="submitDialogVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      @placeOrder="placeOrder"
    />
    <SetSelection
      v-if="setFlagDialogVisible"
      :propGroupData="propGroupData"
      :setFlagDialogVisible="setFlagDialogVisible"
      :addCartOrder="addCartOrder"
      @onCloseSetDialog="onCloseSetDialog"
    />
  </div>
</template>

<script>
import Magnifier from '../moudel/magnifier';
import $ from 'jquery';
import Appheader from '../moudel/Appheader';
import bottom from '../bady_bottom/bottom';
import { debounce } from '@/utils/index';
import {
  getDiamondInfo,
  addCollection,
  getSimilarity,
  getMantleSystem,
  whetherSubscribeTo,
  editSubscribeTo,
  messagePoint,
  getPropGroup,
} from '@/api/detailsApi';
import Spot from './components/Spot.vue';
import Custom from './components/Custom.vue';
import LoversSpot from './components/loversSpot.vue';
import LoversCustom from './components/LoversCustom.vue';
import SetSelection from './components/SetSelection.vue';
import BeInterestedIn from '../../components/BeInterestedIn.vue';
import SimilarRecommendation from '../../components/SimilarRecommendation.vue';
import MantleSystemRecommended from '../../components/MantleSystemRecommended.vue';
import SubmitDialog from '@/components/SubmitDialog.vue';
import { modifyCartPublic, pushOrder } from '@/api/cartApi';
import ls from '@/utils/localStorage';
import { deepClone } from '@/utils/util';
export default {
  components: {
    Magnifier,
    Appheader,
    bottom,
    Spot,
    Custom,
    LoversSpot,
    LoversCustom,
    BeInterestedIn,
    SimilarRecommendation,
    MantleSystemRecommended,
    SubmitDialog,
    SetSelection,
  },
  data() {
    return {
      activeName: 'first',
      submitDialogVisible: false,
      DataList: {
        styleNumber: this.$route.query.styleNumber,
      },
      imgurl: '',
      index: 0, //开始轮播的值
      timer: null, //停止轮播的值
      size: 0, //图片的张数
      picHeight: 0, //图片的高度
      isColleFlag: false,
      recommendationList: [], //相似推荐
      mantleSystemList: [], //套系推荐
      scrollTop: null,
      goTopShow: false,
      isSubscribe: false,
      flag: false,
      goldSettingflag: false,
      placeOrderLoading: false,
      addCartOrder: {},
      isFactoryVisible: false,
      factorySourceState: {
        spot: null,
        custom: null,
        loversSpot: null,
        loversCustom: null,
      },
      standardType: ls.get('standardType'),
      bigSeriesFlag: '',
      propGroupData: [],
      setFlagDialogVisible: false,
      settlementMethodList: [
        { label: '结 料', value: 2 },
        { label: '结 价', value: 1 },
      ], //结算方式
    };
  },
  computed: {
    currentFactorySource() {
      const isCouples = this.DataList.isCouples === '1';
      if (this.activeName === 'second' || this.$route.query.groupFlag == 1) {
        return isCouples ? this.factorySourceState.loversCustom : this.factorySourceState.custom;
      }
      return isCouples ? this.factorySourceState.loversSpot : this.factorySourceState.spot;
    },
    showProcessingFeeFields() {
      return (
        this.isFactoryVisible &&
        this.hasPriceViewPermission() &&
        this.currentFactorySource !== null &&
        this.currentFactorySource !== undefined &&
        `${this.currentFactorySource}` == '1'
      );
    },
  },
  watch: {
    $route: {
      handler() {
        // 获取商品详情
        this.getDiamondInfo();
      },
      deep: true,
    },
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
    this.isFactory()
      .then((res) => {
        this.isFactoryVisible = res;
      })
      .catch(() => {
        this.isFactoryVisible = false;
      });
    // 获取商品详情
    this.getDiamondInfo();
    if (ls.get('coludQuery')) {
      // 埋点
      this.messagePoint('0');
    }
    if (this.$route.query.groupFlag == 1) {
      this.activeName = 'second';
    }
  },
  destroyed() {
    ls.remove('coludQuery');
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    resetFactorySourceState() {
      this.factorySourceState = {
        spot: null,
        custom: null,
        loversSpot: null,
        loversCustom: null,
      };
    },
    updateFactorySource(type, factorySource) {
      this.factorySourceState = {
        ...this.factorySourceState,
        [type]: factorySource,
      };
    },
    // 更新庫存
    upDataStockQuantity(stockQuantity) {
      // this.DataList.stockQuantity = stockQuantity;
    },
    // 关闭弹窗
    onCloseSelectDialog() {
      this.submitDialogVisible = false;
    },
    messagePoint(pointType) {
      const query = {
        styleNumber: this.$route.query.styleNumber,
        pointType: pointType,
      };
      messagePoint(query).then((res) => {});
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scrollTop > 300) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
    bottomScrollClick() {
      let timer = null;
      const _that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_that.scrollTop != 1000) {
          _that.scrollTop = 1000;
          document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _that.goTopShow = true;
        }
      });
    },
    topScrollClick() {
      let timer = null;
      const _that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_that.scrollTop > 0) {
          _that.scrollTop = 0;
          document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _that.goTopShow = false;
        }
      });
    },
    // 复制款号
    seccendCopy() {
      var that = this;
      this.$copyText(this.DataList.styleNumber).then(
        function (e) {
          that.$message({
            message: '复制成功!',
            type: 'success',
            duration: 1500,
          });
        },
        function (e) {
          that.$message({
            message: '复制失败!',
            type: 'warning',
            duration: 1500,
          });
        },
      );
    },
    // 相似推荐-套系推荐
    getRecommendation(styleNumber) {
      //相似推荐
      getSimilarity(styleNumber).then((res) => {
        this.recommendationList = res.data.records || [];
      });
      //套系推荐
      getMantleSystem(styleNumber).then((res) => {
        this.mantleSystemList = res.data.records || [];
      });
    },
    // 点击感兴趣刷新页面
    interestedInUpdata() {
      this.getDiamondInfo();
    },
    //定单现货切换清空所选
    handleClick(tab, event) {
      this.isStyleShape();
    },
    // 订阅-取消订阅
    updateSubscribe() {
      let obj = {
        styleNumber: this.DataList.styleNumber,
        columnCode: this.$route.query.codeType,
        requestFrom: 2,
      };
      if (!this.flag) {
        this.flag = true;
        editSubscribeTo(obj).then((res) => {
          this.isSubscribe = !this.isSubscribe;
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 1000,
          });
          this.flag = false;
        });
      }
    },
    // 查询是否订阅
    whetherSubscribeTo(styleNumber) {
      let obj = {
        styleNumber: styleNumber,
        columnCode: this.$route.query.codeType,
      };
      whetherSubscribeTo(obj).then((res) => {
        this.isSubscribe = res.data;
      });
    },
    // 点击收藏
    colleBtn(text) {
      let obj = {
        id: this.$route.query.styleNumber,
        isLike: text === '收藏' ? 1 : 0,
      };
      addCollection(obj).then((res) => {
        text === '收藏' ? (this.isColleFlag = true) : (this.isColleFlag = false);
        this.$message({
          message: res.data,
          type: 'success',
          duration: 1500,
        });
      });
    },
    // 加入购物车X下单
    pushshopping: debounce(
      function (type) {
        this.addCartOrder = {
          productDtoList: [],
          orderNowDtoList: [],
          shopType: 2,
          type: 1,
          isCouples: this.DataList.isCouples,
          orderPath: 1,
          requestFrom: 1,
          spotFlag: 1,
          purchaseSource: ls.get('coludQuery') ? 0 : 1, //0 云平台产品推荐, 1 其他渠道"
          siteId: ls.get('siteId') || ls.get('userInfo').sysUser?.siteId || '',
        };
        if (this.DataList.isCouples === '1') {
          if (this.activeName === 'first') {
            if (!this.$refs.loversSpot.dataFrom.settlementMethod || !this.$refs.loversSpot.maleDataFrom.settlementMethod) {
              return this.$message({
                message: '请选择结算方式',
                type: 'warning',
                duration: 1500,
              });
            }
            this.addCartOrder.productDtoList.push(this.$refs.loversSpot.dataFrom);
            this.addCartOrder.productDtoList.push(this.$refs.loversSpot.maleDataFrom);
            if (
              (this.$refs.loversSpot.handSizeList.length > 0 && !this.$refs.loversSpot.dataFrom.ringSize) ||
              !this.$refs.loversSpot.dataFrom.goldWeigh ||
              (this.$refs.loversSpot.maleHandSizeList.length > 0 && !this.$refs.loversSpot.maleDataFrom.ringSize) ||
              !this.$refs.loversSpot.maleDataFrom.goldWeigh
            ) {
              return this.$message({
                message: '请选择参数',
                type: 'warning',
                duration: 1500,
              });
            }
            if (
              !this.$refs.loversSpot?.dataFrom?.quantity ||
              this.$refs.loversSpot?.dataFrom?.quantity == 0 ||
              !this.$refs.loversSpot?.maleDataFrom?.quantity ||
              this.$refs.loversSpot?.maleDataFrom?.quantity == 0
            ) {
              return this.$message({
                message: '数量不能为空',
                type: 'warning',
                duration: 1500,
              });
            }
          } else {
            this.addCartOrder.type = 2;
            this.addCartOrder.spotFlag = 2;
            this.addCartOrder.productDtoList.push(this.$refs.loversCustom.dataFrom);
            if (!this.$refs.loversCustom.dataFrom.settlementMethod) {
              return this.$message({
                message: '请选择结算方式',
                type: 'warning',
                duration: 1500,
              });
            }
            if (
              (this.$refs.loversCustom.handSizeList.length > 0 && !this.$refs.loversCustom.dataFrom.ringSize) ||
              !this.$refs.loversCustom.dataFrom.goldWeigh
            ) {
              return this.$message({
                message: '请选择参数',
                type: 'warning',
                duration: 1500,
              });
            }
            if (!this.$refs.loversCustom?.dataFrom?.quantity || this.$refs.loversCustom?.dataFrom?.quantity == 0) {
              return this.$message({
                message: '数量不能为空',
                type: 'warning',
                duration: 1500,
              });
            }
          }
        } else {
          // first现货 second定单
          if (this.activeName === 'first') {
            this.addCartOrder.productDtoList.push(this.$refs.spot.dataFrom);
            if (!this.$refs.spot.dataFrom.settlementMethod) {
              return this.$message({
                message: '请选择结算方式',
                type: 'warning',
                duration: 1500,
              });
            }
            if ((this.$refs.spot.handSizeList.length > 0 && !this.$refs.spot.dataFrom.ringSize) || !this.$refs.spot.dataFrom.goldWeigh) {
              return this.$message({
                message: '请选择参数',
                type: 'warning',
                duration: 1500,
              });
            }
            if (!this.$refs.spot?.dataFrom?.quantity || this.$refs.spot?.dataFrom?.quantity == 0) {
              return this.$message({
                message: '数量不能为空',
                type: 'warning',
                duration: 1500,
              });
            }
          } else {
            this.addCartOrder.type = 2;
            this.addCartOrder.spotFlag = 2;
            this.addCartOrder.productDtoList.push(this.$refs.custom.dataFrom);
            if (!this.$refs.custom.dataFrom.settlementMethod) {
              return this.$message({
                message: '请选择结算方式',
                type: 'warning',
                duration: 1500,
              });
            }
            if ((this.$refs.custom.handSizeList.length > 0 && !this.$refs.custom.dataFrom.ringSize) || !this.$refs.custom.dataFrom.goldWeigh) {
              return this.$message({
                message: '请选择参数',
                type: 'warning',
                duration: 1500,
              });
            }
            if (!this.$refs.custom?.dataFrom?.quantity || this.$refs.custom?.dataFrom?.quantity == 0) {
              return this.$message({
                message: '数量不能为空',
                type: 'warning',
                duration: 1500,
              });
            }
          }
        }
        if (type == 'cart') {
          const addCartOrder = deepClone(this.addCartOrder);
          // 删除所有对象的 mainStone 属性
          addCartOrder.productDtoList.forEach((user) => delete user.mainStone);
          modifyCartPublic(this.addCartOrder, 'post').then((res) => {
            if (res.code == 0) {
              this.$confirm('添加成功', '提示', {
                confirmButtonText: '去购物车',
                cancelButtonText: '继续添加',
                type: 'success',
              })
                .then(() => {
                  this.$router.push('/shoppingCart');
                })
                .catch(() => {});
            }
          });
        } else {
          // if (this.bigSeriesFlag && this.standardType != 'Y' && this.DataList.propGroup == 'A') {
          //   this.fetchPropGroup();
          //   return;
          // }
          this.addCartOrder.orderPath = this.$route.query.groupFlag == 1 ? 4 : this.activeName === 'first' ? 2 : 3;
          this.addCartOrder.orderNowDtoList = deepClone(this.addCartOrder.productDtoList);
          this.submitDialogVisible = true;
        }
      },
      500,
      true,
    ),
    // 关闭套餐弹窗
    onCloseSetDialog(pageData) {
      this.setFlagDialogVisible = false;
      if (pageData) {
        this.addCartOrder.orderPath = this.$route.query.groupFlag == 1 ? 4 : this.activeName === 'first' ? 2 : 3;
        this.addCartOrder.orderNowDtoList = deepClone(this.addCartOrder.productDtoList);
        this.addCartOrder.orderNowDtoList.push(...pageData);
        this.submitDialogVisible = true;
      }
    },
    // 获取九华套组商品
    fetchPropGroup() {
      const query = {
        spotFlag: this.activeName === 'first' ? 1 : 2,
        styleNumber: this.DataList.styleNumber,
      };
      this.propGroupData = [];
      getPropGroup(query).then((res) => {
        if (res.data) {
          this.propGroupData = res.data;
          this.propGroupData.forEach((element, index) => {
            if (element.styleNumber == this.addCartOrder.productDtoList[0].styleNumber) {
              this.propGroupData.splice(index, 1);
            }
          });
          this.setFlagDialogVisible = true;
        } else {
          this.$alert('A组标配13款内存在无现货产品，请前往定制下单', '提示', {
            confirmButtonText: '我已知晓',
            callback: (action) => {
              this.activeName = 'second';
            },
          });
        }
      });
    },
    // 确定下单
    placeOrder(from) {
      if (this.placeOrderLoading) return;

      this.placeOrderLoading = true;
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在提交订单',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
      });
      let orderInfor = deepClone(from);
      delete orderInfor.organizationList;
      // 修改bug
      if (orderInfor.netAddress?.indexOf('-') > 0) {
        orderInfor.netCode = from.netAddress.split('-')[0];
        orderInfor.netAddress = from.netAddress.split('-')[1];
      } else {
        orderInfor.netCode = '';
        orderInfor.netAddress = '';
      }
      this.addCartOrder = { ...this.addCartOrder, ...orderInfor };
      delete this.addCartOrder.productDtoList;
      pushOrder(this.addCartOrder)
        .then((res) => {
          if (res.code === 0) {
            this.submitDialogVisible = false;
            this.$confirm('提交成功', '提示', {
              confirmButtonText: '继续下单',
              cancelButtonText: '查看订单',
              type: 'success',
            })
              .then(() => {
                // 强制刷新页面
                window.location.reload();
              })
              .catch(async () => {
                if (this.$route.query.groupFlag == 1) {
                  this.$router.push('/PresellOrder');
                } else {
                  const isFactoryUser = await this.isFactory().catch(() => false);
                  if (isFactoryUser) {
                    this.$router.push({ path: '/RviewOrder' });
                  } else this.$router.push({ path: '/CommodityOrder' });
                }
              });
          }
        })
        .catch((err) => {
          if (err === '存在已售或下架商品') {
            this.submitDialogVisible = false;
          }
        })
        .finally(() => {
          this.placeOrderLoading = false;
          loadingInstance.close();
        });
    },
    // 移开鼠标从新轮播
    mouseLeave() {
      this.autoSlide(); // 图片开始再次轮播
    },
    // 点击清除定时器
    stopImglunbo() {
      clearInterval(this.timer);
    },
    // 足迹新增
    footMark() {
      var that = this;
      var url = '/footMark/save';
      var data = {
        styleNumber: this.DataList.styleNumber,
        imgUrl: this.DataList.imgPathList[0],
        shopType: this.DataList.shopType,
        title: this.DataList.productName,
        type: this.$route.query.type,
        buyerId: JSON.parse(localStorage.getItem('userData')).userCode,
      };
      that
        .$axios({
          url: url,
          method: 'post',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
          },
          data: JSON.stringify(data),
        })
        .then((re) => {});
    },
    // 判断是不是汝瓷、木雕
    isStyleShape() {
      if (this.DataList.styleShape && (this.DataList.styleShape == '汝瓷' || this.DataList.styleShape == '木雕') && this.activeName == 'second') {
        this.$alert('本款工艺特殊，定制前请与生产管理部确认起订件数，确认后再提交订单，感谢配合！', '温馨提示', {
          confirmButtonText: '确定',
          callback: (action) => {},
        });
      }
    },
    //获取商品详情
    getDiamondInfo() {
      this.resetFactorySourceState();
      const query = {
        styleNumber: this.$route.query.styleNumber,
        classify: this.$route.query.classify,
      };
      getDiamondInfo(query).then((res) => {
        this.DataList = res.data;
        //isCouples 1是情侣款 2 否
        //isPresell 1是预收款 2 否
        //isLike 0是未收藏  2是已收藏
        //isLikeTwo 0是未感兴趣  1是感兴趣
        if (this.DataList.productName.indexOf('黄金镶嵌') != -1) {
          this.goldSettingflag = true;
        }
        if (this.DataList.isLike === '0') {
          this.isColleFlag = false;
        } else {
          this.isColleFlag = true;
        }
        this.imgurl = res.data.imgPathList[0];
        if (res.data.imgPathList.length > 3) {
          this.DataList.imgPathList = res.data.imgPathList.splice(0, 3);
        } else {
          this.DataList.imgPathList = res.data.imgPathList;
        }
        this.isStyleShape();
        // 相识推荐-套系
        this.getRecommendation(this.DataList.styleNumber);
        // 是否订阅
        this.whetherSubscribeTo(this.DataList.styleNumber);
        // 判断是不是寻愿九华系列
        // this.bigSeriesFlag = RegExp(/寻愿九华/).test(this.DataList.bigSeries) ? true : false;
        // if (this.bigSeriesFlag && this.standardType != 'Y' && this.DataList.propGroup == 'B') {
        //   this.$alert('需完成A组标配后可选购B组商品', '提示', {
        //     confirmButtonText: '确定，返回列表',
        //     callback: (action) => {
        //       this.$router.push({ path: '/home' });
        //     },
        //   });
        // }
        // if (this.bigSeriesFlag && this.standardType == 'Y' && this.DataList.propGroup == 'B') {
        //   let dynamicMessage = this.DataList.propGroupRule;
        //   dynamicMessage = dynamicMessage.replace(/\n/g, '');
        //   this.$alert(`${dynamicMessage}`, '提示', {
        //     confirmButtonText: '我已知晓',
        //     dangerouslyUseHTMLString: true, // 允许渲染 HTML 标签
        //     callback: (action) => {
        //       // this.$router.push({ path: '/home' });
        //     },
        //   });
        // }
        // DOM 渲染完毕后执行轮播事件
        this.$nextTick(function () {
          this.picHeight = $('.slide img').width(); //获取宽度度
          this.size = $('.slide').children().length; // 获取图片张数
          this.autoSlide(); //进页面默认轮播
          $('.banner').mouseover(() => {
            clearInterval(this.timer); // 停止图片轮播
          });
          $('.banner').mouseleave(() => {
            this.autoSlide(); // 图片开始再次轮播
          });
          // $('.slide').mouseleave();
        });
      });
    },
    autoSlide() {
      // 图片轮播函数
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        let l = this.DataList.imgPathList.length;
        // debugger
        if (this.index < l) {
          $('.imgbox').removeClass('imgbck');
          $('.imgbox').eq(this.index).addClass('imgbck');
          this.imgurl = this.DataList.imgPathList[this.index];
          this.index++;
        } else {
          $('.imgbox').removeClass('imgbck');
          $('.imgbox').eq(0).addClass('imgbck');
          this.imgurl = this.DataList.imgPathList[0];
          this.index = 1;
        }
      }, 3000); //每隔1.5S就切换一次图片
    },
    // 点击图片从新轮播
    changeImg(index) {
      $('.imgbox').removeClass('imgbck');
      $('.imgbox').eq(index).addClass('imgbck');
      this.imgurl = this.DataList.imgPathList[index];
      this.index = index;
      //  this.autoSlide(); // 图片开始再次轮播
    },
  },
  // 离开页面清除定时器
  beforeDestroy() {
    clearInterval(this.timer);
  },
  beforeRouteLeave(to, from, next) {
    // 从列表页去到别的页面，如果不是详情页，则不缓存列表页
    if (to.name != 'home') {
      this.$route.meta.keepAlive = false;
      this.$route.meta.flag = false;
    } else if (to.name == 'home') {
      this.$route.meta.keepAlive = true;
      this.$route.meta.flag = true;
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.plaingGoldDeatails {
  position: relative;
  .content-box {
    width: 800px;
  }
  .content-details {
    display: flex;
    margin: 10px 0;
    .content-details-child {
      .content-details-text {
        padding: 0 30px 14px 0;
      }
      .copyText {
        color: #ec9368;
        margin-left: 10px;
      }
    }
  }
  .introduction {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cursor {
    cursor: pointer;
  }

  .productNameClass {
    font-size: 24px;
    // color: #ec9368;
  }
}
</style>
<style lang="scss">
@import '@/style/detailsPage.scss';
</style>
